import { forwardRef } from 'react'
import './input.css'

export interface IInputProps {
  value?: string
  placeholder?: string
  onChange?: (value: string) => void
  disabled?: boolean
  type?: string
  error?: boolean
  maxLength?: number
  hasButton?: boolean
  autoFocus?: boolean
  onFocus?: () => void
  classNames?: string
}

export const Input = forwardRef<HTMLInputElement, IInputProps>(
  (
    {
      value: initialValue,
      placeholder,
      onChange,
      disabled = false,
      type = 'text',
      error = false,
      maxLength = 2000,
      hasButton = false,
      autoFocus = false,
      onFocus,
      classNames,
      ...props
    },
    ref
  ) => {

    return (
      <input
        value={initialValue}
        type={type}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        className={`${classNames} not-form-styled text-sm h-[38px] bg-inputBackground border-neutral-7 dark:border-neutral-11 dark:[color-scheme:dark] dark:text-white dark:placeholder-secondaryText ${disabled ? 'disabled bg-gray-200' : 'focus:border-borderPurple focus:border-2 hover:border hover:border-borderPurple hover:dark:border-borderPurple focus:ring-1 focus:ring-borderPurple'} ${error ? 'error bg-red-100' : ''} ${hasButton ? 'pr-10' : ''} rounded`}
        maxLength={maxLength}
        autoFocus={autoFocus}
        ref={ref}
        onFocus={onFocus}
        {...props}
      />
    )
  }
)
